import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlagData from './phoneNumberData.json';
import PhoneField from './phoneField';
import FlagDropdown from './FlagDropDown';

/* istanbul ignore next */
const noop = () => {};
export function buildSortedCountryItems(flagData) {
    return Object.keys(flagData)
        .sort((a, b) => (flagData[a].name.toUpperCase()
            < flagData[b].name.toUpperCase()
            ? -1
            : 1))
        .map((cc) => {
            const data = flagData[cc];
            return {
                value: cc,
                text: `${data.name} (+${data.phoneCode})`
            };
        });
}

export const Phone = (props) => {
    const {
        id,
        phoneNumber,
        countryCode,
        showCountrySelect,
        errorMsg,
        onCountryCodeChange,
        onPhoneChange,
        onPhoneFocus,
        onPhoneBlur,
        onError,
        labels,
        countryCodes
    } = props;

    const flagData = Object.keys(FlagData).reduce((data, key) => {
        const dataVal = data;
        const { ...obj } = FlagData[key];
        dataVal[key] = obj;
        return data;
    }, {});

    function getCountryData() {
        const newCountryData = flagData[countryCode];
        if (!countryCode || !newCountryData) {
            onError(new Error('Invalid country code'));
            return flagData.default;
        }
        return newCountryData;
    }

    const [phoneCode, setPhoneCode] = useState('1');
    const [phoneMasks, setPhoneMasks] = useState([]);
    const [dropdownItems, setDropdownItems] = useState(buildSortedCountryItems(flagData));
    const [countryData, setCountryData] = useState(getCountryData());

    function mergeFlagData() {
        // eslint-disable-next-line array-callback-return
        Object.keys(countryCodes).map((code) => {
            const matchingCountryObject = flagData[code];
            if (matchingCountryObject) {
                matchingCountryObject.name = countryCodes[code];
            }
        });

        setDropdownItems(buildSortedCountryItems(flagData));
    }

    function handleCountryCodeChange(e) {
        if (!e || !e.target || !e.target.value) {
            return;
        }
        const cc = e.target.value;
        if (flagData[cc]) {
            flagData[cc].cc = cc;
            setCountryData(flagData[cc]);
            onCountryCodeChange(e, flagData[cc]);
        }
    }

    useEffect(() => {
        if (countryCodes) {
            mergeFlagData();
        }
    }, [countryCodes]);

    useEffect(() => {
        setCountryData(getCountryData());
    }, [countryCode]);

    useEffect(() => {
        if (countryData) {
            setPhoneCode(countryData.phoneCode);
            setPhoneMasks(countryData.masks);
        }
    }, [countryData]);

    const containerClassName = classNames({
        'react-input-tel': true,
        'input-group': true
    });

    return (
        <div className={containerClassName}>
            {showCountrySelect && (
                <FlagDropdown
                    id={`${id}__dropdown`}
                    phoneCode={phoneCode}
                    countryCode={countryCode}
                    items={dropdownItems}
                    onChange={handleCountryCodeChange}
                    labels={labels}
                />
            )}
            <PhoneField
                id={`${id}__input`}
                phoneCode={phoneCode}
                labels={labels}
                masks={phoneMasks}
                phoneNumber={phoneNumber}
                errorMsg={errorMsg}
                onChange={onPhoneChange}
                onFocus={onPhoneFocus}
                onBlur={onPhoneBlur}
                showCountrySelect={showCountrySelect}
            />
        </div>
    );
};

Phone.propTypes = {
    id: PropTypes.string,
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string,
    showCountrySelect: PropTypes.bool,
    errorMsg: PropTypes.string,
    onCountryCodeChange: PropTypes.func,
    onPhoneChange: PropTypes.func,
    onPhoneFocus: PropTypes.func,
    onPhoneBlur: PropTypes.func,
    onError: PropTypes.func,
    labels: PropTypes.shape({
        phoneNumber: PropTypes.string,
        countryCode: PropTypes.string
    }),
    countryCodes: PropTypes.objectOf(PropTypes.string)
};

Phone.defaultProps = {
    id: 'react-input-tel',
    phoneNumber: '',
    countryCode: 'us',
    showCountrySelect: true,
    errorMsg: '',
    onCountryCodeChange: noop,
    onPhoneChange: noop,
    onPhoneFocus: noop,
    onPhoneBlur: noop,
    onError: noop,
    labels: {
        phoneNumber: 'Phone Number',
        countryCode: 'Country Code'
    },
    countryCodes: {}
};
export default Phone;
